<template>
  <div :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']">
    <nav-bar
      fixed
      z-index="99"
      title="教练详情"
      left-text="返回"
      left-arrow
      @click-left="toBack"
    />
    <div style="height: 46px"></div>
    <!--
    <product-con-swiper
      :img-urls="storeInfo.sliderImage"
    ></product-con-swiper>
    -->
    <img style="width: 100%" :src="storeInfo.sliderImage" />
    <div class="product-top">
      <div class="acea-row row-between-wrapper">
        <div class="name">{{ storeInfo.storeName }}</div>
        <div class="price">
          ￥{{ pageType == "coach" ? storeInfo.welfarePrice : storeInfo.price }}
        </div>
      </div>
      <div class="introduce" v-html="storeInfo.description"></div>
      <div class="align-center message">
        <div class="acea-row row-wrap">
          <div class="message-item acea-row row-middle" style="width: 44%">
            <div>教练客户时长：</div>
            <div class="item-num">{{ storeInfo.coachTime || 0 }}小时</div>
          </div>
          <div class="message-item acea-row row-middle" style="width: 56%">
            <div>约见方式：</div>
            <div class="item-num">
              {{
                ($store.state.app.dictObj.meet_type && storeInfo.meetType
                  ? meetTypeText(storeInfo.meetType)
                  : "") || "无"
              }}
            </div>
          </div>
          <div class="message-item acea-row row-middle" style="width: 44%">
            <div>教练学习时长：</div>
            <div class="item-num">{{ storeInfo.teachTime || 0 }}小时</div>
          </div>
          <div class="message-item acea-row row-middle" style="width: 56%">
            <div>地区：</div>
            <div class="item-num">{{ city || "无" }}</div>
          </div>
          <!-- <div class="message-item acea-row row-middle" style="width: 56%">
            <div>文章/视频：</div>
            <a :href="storeInfo.linkUrl" class="item-num">{{
              storeInfo.title
            }}</a>
          </div> -->
        </div>
        <div @click="shareShow = true">
          <img width="20" height="20" src="@/assets/img/Share.png" alt="" />
        </div>
      </div>
      <div class="top-bg">
        <img style="width: 100%" src="@assets/img/detail_w.png" />
      </div>
    </div>
    <div class="product-box" v-if="storeInfo.storeInfo">
      <div class="title">教练介绍</div>
      <div class="info" v-html="storeInfo.storeInfo"></div>
    </div>
    <div class="product-box" v-if="storeInfo.practiceExperience">
      <div class="title">从事职业</div>
      <div class="info">
        {{ storeInfo.practiceExperience }}
      </div>
    </div>
    <div
      class="product-box"
      v-show="
        (storeInfo.title || '').split(';').filter((item) => item != '').length >
        0
      "
    >
      <div class="title">文章/视频</div>
      <div class="info">
        <template v-for="(item, index) in (storeInfo.title || '').split(';')">
          <div :key="index">
            <a
              class="title-info-text"
              :href="(storeInfo.linkUrl || '').split(';')[index] || ''"
            >{{ item }}</a
            >
            <!-- 虚线 -->
            <div class="title-info-line"></div>
          </div>
        </template>
      </div>
    </div>
    <div class="product-box" v-if="zone.length > 0">
      <div class="title">擅长领域</div>
      <div class="acea-row row-center-wrapper row-wrap">
        <div
          class="zone-item"
          style="background: #ffffff"
          v-for="(item, index) in zone"
          :key="index"
        >
          <img class="icon" :src="item.pic" />
          <p>{{ item.cateName }}</p>
        </div>
      </div>
    </div>
    <div
      class="product-box"
      v-if="storeInfo.aptitudeList && storeInfo.aptitudeList.length > 0"
    >
      <div class="title">专业资质</div>
      <div class="info">
        <img
          style="width: 100%"
          :src="item"
          v-for="(item, index) in storeInfo.aptitudeList"
          :key="index"
        />
      </div>
    </div>
    <div
      class="product-box"
      v-if="storeInfo.posterList && storeInfo.posterList.length"
    >
      <div class="title">个人海报</div>
      <div class="info">
        <img
          style="width: 100%"
          :src="item"
          v-for="(item, index) in storeInfo.posterList"
          :key="index"
        />
      </div>
    </div>
    <div class="product-box">
      <div class="title">用户评价</div>
      <user-evaluation :reply="reply" v-if="reply.length"></user-evaluation>
      <div style="padding: 0.4rem; text-align: center" v-else>暂无相关评价</div>
      <div
        style="text-align: center"
        @click="$router.push('/evaluate_list/' + id)"
        v-if="reply.length"
      >
        查看全部评价
      </div>
    </div>
    <div class="product-box" v-show="pageType != 'coach' && feeDesc">
      <div class="title">收费说明</div>
      <div class="info" v-html="feeDesc"></div>
    </div>
    <div class="product-box" v-show="pageType == 'coach' && welfareDesc">
      <div class="title">公益收费说明</div>
      <div class="info" v-html="welfareDesc"></div>
    </div>
    <div style="height: 2rem"></div>
    <div
      class="product-footer acea-row row-between-wrapper"
    >
      <template v-if="pageType != 'coach'">
        <div
          v-if="firstReservation != 0 && $store.state.app.isFirst < $store.state.app.firstNumber
          && !$store.state.app.productIds.includes(Number(id))"
          class="btn acea-row row-center-wrapper bg-color-theme"
          :class="{
            'disable-btn':
              $store.state.app.isFirst > $store.state.app.firstNumber,
          }"
          @click="agreeShow(0)"
        >
          首次体验<br/> ￥
          {{
            $store.state.app.isFree
              ? "0"
              : Number($store.state.app.dictObj.first_price)
          }}/次
        </div>

        <div
          v-else
          class="btn acea-row row-center-wrapper bg-color-theme"
          @click="agreeShow(3)"
        >
          单次 <br/>￥ {{ storeInfo.price }}/次(线上)
        </div>

        <div
          class="btn acea-row row-center-wrapper bg-color-orange"
          @click="agreeShow(1)"
        >
          教练旅程 <br/>￥ {{ storeInfo.price }}/次(线上)
        </div>
      </template>

      <div
        v-else
        class="btn acea-row row-center-wrapper bg-color-orange"
        @click="agreeShow(2)"
        :style="{
          width: '100%',
        }"
      >
        公益价格 ￥ {{ Number(storeInfo.welfarePrice) }}（{{
          Number(storeInfo.welfareNum)
        }}次）
      </div>
    </div>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
    <Popup v-model="showDialog" round>
      <div class="agree-title">
        <template v-if="pageType != 'coach'">
          {{ [0, 3].includes(type) ? articleInfo.title : articleInfo1.title }}
        </template>
        <template v-else>
          {{ articleInfo2.title }}
        </template>
      </div>
      <div class="agree-content">
        <template v-if="pageType != 'coach'">
          <div v-html="articleInfo.content" v-if="[0, 3].includes(type)"></div>
          <div v-html="articleInfo1.content" v-else></div>
        </template>
        <template v-else>
          <div v-html="articleInfo2.content"></div>
        </template>
      </div>
      <div class="agree-btn" @click="dialogAction(true)">确认</div>
    </Popup>

    <Popup v-model="shareShow" position="bottom" :style="{ height: '13%' }">
      <!-- 左右：分享海报、复制链接 -->
      <Grid :column-num="2" class="align-center">
        <GridItem icon="photo-o" text="生成海报" @click="shareImg" />
        <GridItem icon="label-o" text="分享教练" @click="setShareInfoStatus" />
      </Grid>
    </Popup>
    <Popup
      style="height: '400px'"
      v-model="shareImgShow"
      :style="{ height: '400px', width: '270px' }"
    >
      <div class="poster-box">
        <Loading vertical type="spinner" size="30px" v-show="posterLoading"
        >海报生成中</Loading
        >
        <img
          ref="mydialogImg"
          v-show="!posterLoading"
          id="mydialogImg"
          width="250"
          height="100%"
          alt=""
          :src="posterBase64"
        />
      </div>
    </Popup>

    <canvas v-show="false" id="canvas" canvas-id="canvas" />
    <canvas v-show="false" id="myCanvas" canvas-id="myCanvas" />
  </div>
</template>
<script>
import "@assets/css/swiper.min.css";
import ProductConSwiper from "@components/ProductConSwiper";
import UserEvaluation from "@components/UserEvaluation";
import ShareInfo from "@components/ShareInfo";
import QRCode from "qrcode";
import BackImg from "@/assets/img/test.jpg";
import { createOrder, postOrderConfirm } from "@api/order";
import {
  getProductPoster,
  getCategory,
  getProductDetail,
  postCartAdd,
  getReplyList,
} from "@api/store";
import { pay } from "@libs/wechat";
import { getUserInfo, getCity, getRecordInfo } from "@api/user";
import { isWeixin } from "@utils/index";
import { wechatEvevt, openShareAppMessage, openShareAll } from "@libs/wechat";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
import { getDict } from "@api/admin";
import {
  NavBar,
  Popup,
  Grid,
  GridItem,
  Icon,
  Image as VanImage,
  Loading,
  Toast,
} from "vant";
import { getViewDetails, getShare } from "@api/public";

const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
// const MAPKEY = "mapKey";
const _isWeixin = isWeixin();
export default {
  name: "GoodsCon",
  components: {
    ProductConSwiper,
    UserEvaluation,
    ShareInfo,
    NavBar,
    Popup,
    Grid,
    GridItem,
    Icon,
    VanImage,
    Loading,
  },
  data: function () {
    return {
      locationShow: false,
      shareInfoStatus: false,
      weixinStatus: false,
      mapShow: false,
      mapKey: "",
      posterData: {
        codeBase: "",
        title: "",
        price: "",
        code: "",
      },
      posterImageStatus: false,
      animated: false,
      coupon: {
        coupon: false,
        list: [],
      },
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {},
      },
      isOpen: false, //是否打开属性组件
      productValue: [],
      id: 0,
      storeInfo: {},
      firstReservation: 0,//是否开启首单
      couponList: [],
      attrTxt: "请选择",
      attrValue: "",
      cart_num: 1, //购买数量
      replyCount: "",
      replyChance: "",
      reply: [],
      priceName: 0,
      CartCount: 0,
      posters: false,
      banner: [{}, {}],
      swiperRecommend: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: false,
        loop: false,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      system_store: {},
      tempName: "全国包邮",
      zone: [],
      city: "",
      showDialog: false,
      type: 1,
      articleInfo: {},
      articleInfo1: {},
      articleInfo2: {},
      feeDesc: "",
      welfareDesc: "",
      shareShow: false,
      pageType: "coach",
      articleList: [],
      shareImgShow: false,
      from: _isWeixin ? "weixin" : "weixinh5",
      posterHtmlBg:
        "https://img.zcool.cn/community/0159845bd6758ca801213dea3ad769.jpg@3000w_1l_0o_100sh.jpg", // 背景图
      // 二维码的dataUrl
      qrcodeUrl: "",
      // 生成二维码的url
      creatCodeUrl: "",
      // 销售侧点击分享图片
      showSharePopup: false,

      // 最后生成的海报base64
      posterBase64: "",

      posterLoading: false,

      globalShare: {
        globalCoachShareTitle: "",
        globalCoachShareDesc: "",
      },
    };
  },
  computed: mapGetters(["isLogin", "storeItems", "userInfo"]),
  async created() {
    this.isLogin && this.User();

    if (this.isLogin && this.$route.query.recordId) {
      console.log("denglule");
      await this.getRecordDetail();
    }

    this.pageType = this.$route.query.pageType;
  },
  mounted: async function () {
    this.id = this.$route.params.id;

    this.getAgree();
    const data = {
      from: this.pageType == "coach" ? true : undefined,
    };
    await this.getDetail(data)
      .then(() => {
        // this.getCartInfo();
        this.setOpenShare2();
      })
      .catch((e) => {
        console.log(e);
      });
    this.getProductReplyList();
  },
  methods: {
    User: function () {
      let that = this;
      getUserInfo().then((res) => {
        this.$store.commit("SET_USER", res.data);
      });
    },
    toText(HTML) {
      var input = HTML;
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
        .replace(/<[^>]+?>/g, "")
        .replace(/\s+/g, " ")
        .replace(/ /g, " ")
        .replace(/>/g, " ");
    },
    // 获取公益教练详情
    async getRecordDetail() {
      const recordId = this.$route.query.recordId;
      const userRes = await getUserInfo();
      return new Promise((resolve, reject) => {
        getRecordInfo(recordId)
          .then((res) => {
            console.log(res.data.phone, userRes.data.phone);
            if (res.data.phone == userRes.data.phone) {
              this.$router.push({
                path: "/detail/" + res.data.productId,
                query: {
                  pageType: "coach",
                },
              });
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 获取评论列表
    getProductReplyList: function () {
      let q = { page: 1, limit: 5 };
      getReplyList(this.id, q).then((res) => {
        this.reply = res.data;
      });
    },
    // 获取各种协议
    getAgree: function () {
      getViewDetails(48).then((res) => {
        this.articleInfo = res.data;
      });
      getViewDetails(51).then((res) => {
        this.articleInfo1 = res.data;
      });
      getViewDetails(53).then((res) => {
        this.articleInfo2 = res.data;
      });
    },
    loadCategoryData: function () {
      getCategory().then((res) => {
        const cateIds = (this.storeInfo.cateId || "").split(",");
        this.zone = res.data.filter((item) =>
          cateIds.includes(item.id.toString())
        );
        let len = res.data.length;
        if (this.storeInfo.keyword) {
          const keywords = this.storeInfo.keyword.split(",");
          console.log(344, keywords);
          this.zone = [
            ...this.zone,
            ...keywords.map((item) => {
              let index = parseInt(Math.random() * len);
              return {
                cateName: item,
                pic: res.data[index].pic,
              };
            }),
          ];
        }
      });
    },
    // 获取城市列表
    getCityList: function () {
      getCity().then((res) => {
        const province =
          res.data.find((item) => item.v == this.storeInfo.provinceCode) || {};
        this.city = Array.isArray(province.c)
          ? province.c.find((item) => item.v == this.storeInfo.cityCode).n
          : province.n;
      });
    },
    // 获取教练详情
    getDetail: async function (data) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getProductDetail(this.id, data);
          // console.log("productValue res", res.data.productValue);

          if (res.status === 200) {
            // 判断，如果是从跳转进入的话，如果当前不是公益教练，则跳转首页
            if (
              res.data.storeInfo.coachType != 1 &&
              res.data.storeInfo.coachType != 2 &&
              this.pageType == "coach"
            ) {
              this.$dialog.toast({ mes: "该公益教练已下架" });
              this.$router.push("/");
            }

            let arr = [];
            for (let key in res.data.productValue) {
              arr.push({
                num: key,
                id: res.data.productValue[key].id,
                price: res.data.productValue[key].price,
                unique: res.data.productValue[key].unique,
                skuName: res.data.productValue[key].skuName,
              });
            }

            this.storeInfo = res.data.storeInfo;
            this.firstReservation = res.data.lcCoachExtendInfo.firstReservation;//是否开启首单
            this.productValue = arr;
            res.data.storeInfo.storeInfo &&
            (this.storeInfo.storeInfo = res.data.storeInfo.storeInfo.replace(
              /\n/g,
              "<br/>"
            ));
            this.globalShare.globalCoachShareTitle =
              res.data.globalCoachShareTitle;
            this.globalShare.globalCoachShareDesc =
              res.data.globalCoachShareDesc;
            this.welfareDesc = res.data.welfareDesc;
            this.storeInfo.aptitudeList =
              res.data.lcCoachExtendInfo.aptitudeList;
            this.storeInfo.posterList =
              res.data.lcCoachExtendInfo.posterList || [];
            this.feeDesc = res.data.feeDesc;
            this.welfareDesc = res.data.welfareDesc;
            this.loadCategoryData();
            this.getCityList();
            resolve();
          }
        } catch (e) {
          // reject(e)
          this.$dialog.toast({ mes: "该教练已下架" });
          this.$router.push("/");
        }
      });
    },
    // 判断当前是不是通过推广链接进入的
    isSpread() {},
    getWXLocation() {
      if (isWeixin()) {
        let _this = this;
        wechatEvevt("getLocation", { type: "wgs84" })
          .then((res) => {
            let latitude = res.latitude; // 纬度
            let longitude = res.longitude; // 经度
            cookie.set(LATITUDE, latitude);
            cookie.set(LONGITUDE, longitude);
          })
          .catch((res) => {
            if (res.is_ready) {
              res.wx.getLocation({
                success(res) {
                  let latitude = res.latitude; // 纬度
                  let longitude = res.longitude; // 经度
                  cookie.set(LATITUDE, latitude);
                  cookie.set(LONGITUDE, longitude);
                },
                cancel() {
                  _this.$dialog.error("取消获取位置");
                  cookie.remove(LATITUDE);
                  cookie.remove(LONGITUDE);
                },
                fail() {
                  _this.$dialog.error("授权失败");
                  cookie.remove(LATITUDE);
                  cookie.remove(LONGITUDE);
                },
              });
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error("定位失败，请配置您的腾讯地图key");
        let loc;
        // 腾讯地图监听定位组件的message事件
        console.log("aaaa:" + this.mapKey);
        if (this.mapKey) this.locationShow = true;
        window.addEventListener(
          "message",
          function (event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    updateTitle() {
      document.title = this.storeInfo.storeName || this.$route.meta.title;
    },
    hasPreviousRoute() {
      return window.history.length > 1;
    },
    toBack() {
      if (this.$route.query.source) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
      // if (this.pageType == "coach") {
      //   this.$router.push("/");
      //   return;
      // }
      // if (this.hasPreviousRoute()) {
      //   console.log("back");
      //   this.$router.go(-1);
      // } else {
      //   this.$router.push("/");
      // }
    },
    setOpenShare: function () {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then((res) => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              desc: data.storeInfo,
              title: data.storeName,
              link: href,
              imgUrl: data.image,
            };
            wechatEvevt(
              ["updateAppMessageShareData", "updateTimelineShareData"],
              configAppMessage
            )
              .then((res) => {
                console.log(res);
              })
              .catch((res) => {
                console.log(res);
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: data.storeInfo,
            title: data.storeName,
            link: href,
            imgUrl: data.image,
          };
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then((res) => {
              console.log(res);
            })
            .catch((res) => {
              console.log(res);
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            });
        }
      }
    },
    setShareInfoStatus: function () {
      this.shareShow = false;
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
      // this.setOpenShare();
    },
    setOpenShare2: async function () {
      if (isWeixin()) {
        var configAppMessage = {
          desc:
            this.storeInfo.shareDesc ||
            this.globalShare.globalCoachShareDesc ||
            this.toText(this.storeInfo.storeInfo),
          title:
            this.storeInfo.shareTitle ||
            this.globalShare.globalCoachShareTitle ||
            this.storeInfo.storeName + "-蒲公英教练平台",
          link: location.href,
          imgUrl: this.storeInfo.image,
        };
        // var configAppMessage = {
        //   desc: "this.storeInfo.storeInfo",
        //   title: "蒲公英家教平台",
        //   link: location.href,
        //   imgUrl: this.storeInfo.image,
        // };
        // console.log("configAppMessage222", configAppMessage);
        openShareAll(configAppMessage);
      }
    },
    setPosterImageStatus: function () {
      let that = this;
      let data = {
        from: "h5",
      };
      getProductPoster(that.id, data)
        .then((res) => {
          that.posterData.codeBase = res.data;
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    // 弹出协议弹窗确认前置操作
    agreeShow(type) {
      this.type = type;
      if (this.isLogin) {
        // 直接跳转问卷页面，不再弹出协议
        if (this.type == 0) {
          // 首约
          this.$router.push({
            path: `/order/questionnaire/${this.id}`,
            query:
              this.pageType == "coach"
                ? {
                  type: 0,
                  pageType: this.pageType,
                  // 0测评 1私域 2平台
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                }
                : {
                  type: 0,
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                },
          });
        } else if (this.pageType == "coach") {
          // 公益
          this.$router.push({
            path: `/order/questionnaire/${this.id}`,
            query: {
              type: 2,
              pageType: this.pageType,
              source: this.$route.query.source || 2,
              reviewOrderId: this.$route.query.reviewOrderId,
            },
          });
        } else if (this.type == 3) {
          // 单次
          this.$router.push({
            path: `/order/questionnaire/${this.id}`,
            query:
              this.pageType == "coach"
                ? {
                  type: 3,
                  pageType: this.pageType,
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                }
                : {
                  type: 3,
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                },
          });
        } else {
          // 续约
          this.$router.push({
            path: `/order/questionnaire/${this.id}`,
            query: {
              type: 1,
              source: this.$route.query.source || 2,
              reviewOrderId: this.$route.query.reviewOrderId,
            },
          });
        }
      } else {
        this.$router.push({
          path: "/login",
          query: { redirect: this.$route.fullPath },
        });
      }
    },
    dialogAction: async function (e) {
      this.showDialog = false;
      if (e) {
        if (this.type == 0) {
          // 首约
          this.$router.push({
            path: `/order/questionnaire/${this.id}`,
            query:
              this.pageType == "coach"
                ? {
                  type: 0,
                  pageType: this.pageType,
                  // 0测评 1私域 2平台
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                }
                : {
                  type: 0,
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                },
          });
        } else if (this.pageType == "coach") {
          await this.getCartInfo();
          // 公益
          this.createOrder(1);
        } else if (this.type == 3) {
          // this.createOrder(0);
          // 单次
          this.$router.push({
            path: `/order/questionnaire/${this.id}`,
            query:
              this.pageType == "coach"
                ? {
                  type: 3,
                  pageType: this.pageType,
                  // 0测评 1私域 2平台
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                }
                : {
                  type: 3,
                  source: this.$route.query.source || 2,
                  reviewOrderId: this.$route.query.reviewOrderId,
                },
          });
        } else {
          // 续约
          this.$router.push({
            // path: `/order/submit/${this.id}`,
            path: `/order/questionnaire/${this.id}`,
            query: {
              type: 1,
              // 0测评 1私域 2平台
              source: this.$route.query.source || 2,
              reviewOrderId: this.$route.query.reviewOrderId,
            },
          });
        }
      }
    },
    meetTypeText(meetType) {
      return meetType
        .split(",")
        .map((item) => this.$store.state.app.dictObj.meet_type[item])
        .join("/");
    },
    async shareImg() {
      this.shareShow = false;
      // 修改海报背景图
      if (this.storeInfo.posterList.length == 0) {
        // 提示用户没有海报
        Toast("该教练没有海报");
        return;
      }
      this.posterHtmlBg = this.storeInfo.posterList[0];
      this.posterLoading = true;
      this.shareImgShow = true;
      this.showSharePopup = true;
      this.posterBase64 = "";

      // 获取当前页面的链接
      let url = window.location.href;
      this.creatCodeUrl = url;
      await this.createQrcode(this.creatCodeUrl);
      this.drawAndShareImage(this.posterHtmlBg, this.qrcodeUrl, "");
    },
    // 创建海报二维码
    createQrcode(text) {
      // 生成二维码
      const canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, text, {
        margin: 0,
      });
      let data = canvas.toDataURL("image/png", 1);
      this.qrcodeUrl = data;
    },
    //img1背景图、img2二维码
    drawAndShareImage(img1, img2) {
      let canvas = document.getElementById("myCanvas");
      canvas.width = 1100;
      canvas.height = 1600;
      let context = canvas.getContext("2d");
      context.rect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "#fff";
      context.fill();
      let myImage = new Image();
      myImage.crossOrigin = "Anonymous";
      myImage.src = img1 + "?v=" + Math.random();
      myImage.onerror = () => {
        //报错时向链接后添加一个随机参数
        console.log("报错了");
        this.posterLoading = false;
      };
      myImage.onload = () => {
        context.drawImage(myImage, 0, 0, canvas.width, canvas.height);
        let myImage2 = new Image();
        myImage2.crossOrigin = "Anonymous";
        myImage2.src = img2;
        myImage2.onerror = () => {
          //报错时向链接后添加一个随机参数
          console.log("报错了");
          this.posterLoading = false;
        };
        myImage2.onload = () => {
          context.drawImage(myImage2, 860, 1370, 200, 200);
          let base64 = canvas.toDataURL("image/png");
          this.posterLoading = false;
          this.posterBase64 = base64;
        };
      };
    },
    // 相当于加入购物车
    async getCartInfo() {
      let uniqueIdRe = "";
      for (let item of this.productValue) {
        if (item.sku == 1) {
          uniqueIdRe = item.unique;
        }
      }
      let q = {
        productId: this.$route.params.id,
        cartNum: 1,
        new: 1,
        uniqueId: this.type == 1 ? uniqueIdRe : "",
        from: this.pageType == "coach" ? '1' : undefined,
      };
      const cartData = await postCartAdd(q);
      const cartIds = cartData.data.cartId;
      this.cartid = cartData.data.cartId;
      // 单次 0 (value = "订单类型 0 普通订单 1首约订单 2公益订单")
      const type = this.pageType == "coach" ? 2 : 0;
      return new Promise((resolve, reject) => {
        postOrderConfirm(cartIds, type)
          .then((res) => {
            this.offlinePayStatus = res.data.offline_pay_status;
            this.orderGroupInfo = res.data;
            this.deduction = res.data.deduction;
            this.enableIntegral = res.data.enableIntegral;
            this.enableIntegralNum = res.data.enableIntegralNum;
            this.usableCoupon = res.data.usableCoupon || {};
            this.addressInfo = res.data.addressInfo || {};
            this.system_store = res.data.systemStore || {};
            this.store_self_mention = res.data.storeSelfMention;
            resolve(true);
          })
          .catch(() => {
            this.$dialog.error("加载订单数据失败");
            reject(false);
          });
      });
    },

    async createOrder(welfareOrder) {
      // console.log(this.orderGroupInfo)
      // return
      this.$dialog.confirm({
        mes: "是否确认进行付款？",
        opts: async () => {
          const userRes = await getUserInfo();
          const userInfo = userRes.data;
          if (!userInfo.phone) {
            this.$dialog.confirm({
              mes: "您的用户基础信息尚未填写，为了便于教练联系到您，请补充完整。",
              opts: [
                {
                  txt: "返回",
                  color: false,
                  callback: () => {
                    this.$router.go(-1);
                  },
                },
                {
                  txt: "去完善",
                  color: true,
                  callback: () => {
                    this.$router.push("/settle_in?stepActive=1");
                  },
                },
              ],
            });
            return;
          }

          if (this.onBtn) return;
          this.onBtn = true;
          this.$dialog.loading.open("生成订单中");
          createOrder(this.orderGroupInfo.orderKey, {
            realName: "",
            phone: "",
            addressId: null,
            channelid: null,
            welfareOrder: welfareOrder,
            useIntegral: 0,
            couponId: 0,
            payType: "weixin",
            pinkId: 0,
            seckillId: 1,
            from: this.from,
            combinationId: this.orderGroupInfo.combination_id,
            bargainId: this.orderGroupInfo.bargain_id,
            mark: "",
            shippingType: 1,
            storeId: this.storeItems.id || this.system_store.id,
            firstOrder: 0,
            // 来源ID
            source: this.$route.query.source,
            // 如有测评ID
            reviewOrderId: this.$route.query.reviewOrderId,
          })
            .then((res) => {
              this.onBtn = false;
              this.$dialog.loading.close();
              const data = res.data;
              switch (data.status) {
                case "ORDER_EXIST":
                case "EXTEND_ORDER":
                case "PAY_DEFICIENCY":
                case "PAY_ERROR":
                  this.$dialog.toast({ mes: res.msg });
                  this.$router.replace({
                    path: "/order/status/" + data.result.orderId,
                    query: { type: this.type },
                  });
                  break;
                case "SUCCESS":
                  this.$dialog.success(res.msg);
                  this.$router.replace({
                    path: "/order/status/" + data.result.orderId,
                    query: {
                      price:
                        this.type == 1
                          ? this.productValue[0].price
                          : this.first_price,
                      type: this.type,
                    },
                  });
                  break;
                case "WECHAT_H5_PAY":
                  this.$router.replace({
                    path: "/order/status/" + data.result.orderId,
                    query: {
                      price:
                        this.type == 1
                          ? this.productValue[0].price
                          : this.first_price,
                      type: this.type,
                    },
                  });
                  setTimeout(() => {
                    location.href = data.result.jsConfig.mweb_url;
                  }, 100);
                  break;
                case "WECHAT_PAY":
                  pay(data.result.jsConfig).finally(() => {
                    this.$router.replace({
                      path: "/order/status/" + data.result.orderId,
                      query: {
                        price:
                          this.type == 1
                            ? this.productValue[0].price
                            : this.first_price,
                        type: this.type,
                      },
                    });
                  });
              }
            })
            .catch((err) => {
              console.log(err);
              this.onBtn = false;
              this.$dialog.loading.close();
              this.$dialog.error(err.msg || "创建订单失败");
            });
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.product-con {
  .product-top {
    background-color: #ffffff;
    padding: 0.3rem 0.3rem 1rem;
    border-radius: 0.3rem 0.3rem 0 0;
    position: relative;

    .top-bg {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .name {
      font-size: 0.3rem;
      font-weight: 700;
    }

    .price {
      color: #ff7733;
    }

    .introduce {
      margin-top: 0.19rem;
      line-height: 0.46rem;
      color: #666666;
    }

    .message {
      margin-top: 0.4rem;
    }

    .message-item {
      text-align: center;
      margin-bottom: 0.19rem;
      font-size: 0.24rem;
    }

    .item-num {
      color: #ff7733;
      font-weight: 600;
    }
  }

  .product-box {
    padding: 0.3rem;
    background-color: #ffffff;
    margin-top: 0.24rem;

    .title {
      text-align: center;
      background: url("~@/assets/img/detail_title.png") no-repeat;
      background-size: 2.8rem 0.5rem;
      background-position: center;
      color: #ffffff;
      padding: 0.2rem 0;

      &-info-text {
        font-size: 0.24rem;
        color: rgb(12, 230, 223);
        // margin-left: 0.2rem;
      }

      &-info-line {
        // 分割线，虚线
        margin: 0.1rem 0;
        width: 100%;
        height: 0.01rem;
        border-bottom: 1px dashed #eee;
      }
    }

    .info {
      line-height: 0.46rem;
      margin-top: 0.2rem;
      color: #333333;
    }
  }
}

.product-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: constant(safe-area-inset-bottom);
  bottom: env(safe-area-inset-bottom);
  background: #ffffff;
  padding: 0.46rem 0.1rem;

  .btn {
    width: 3.5rem;
    height: 0.8rem;
    border-radius: 0.4rem;
    color: #ffffff;
    text-align:center;
  }
}

.generate-posters {
  width: 100%;
  height: 4rem;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}

.zone-item {
  width: 1.7rem;
  padding: 0.19rem 0;
  background-color: #f6f4f5;
  font-size: 0.23rem;
  text-align: center;
  margin-top: 0.3rem;
}

.zone-item .icon {
  width: auto;
  height: 0.7rem;
}

.zone-item p {
  margin-top: 0.1rem;
  font-size: 0.23rem;
}

.agree-content {
  width: 80vw;
  min-height: 20vh;
  max-height: 60vh;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0.3rem;
}

.agree-title {
  padding: 0.3rem;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}

.agree-btn {
  display: block;
  color: #fff;
  height: 0.68rem;
  background: #0ce6df;
  line-height: 0.68rem;
  text-align: center;
  border-radius: 0.5rem;
  margin: 0.3rem;
}

.generate-posters .icon-guanbi {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 20px;
  color: #8a8a8a;
}

.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}

.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}

.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}

.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}

.noscroll {
  height: 100%;
  overflow: hidden;
}

.generate-posters .item img {
  width: 100px;
  height: 100px;
  background-color: #f7f7f7;
  padding: 20px;
  border-radius: 50%;
  margin: auto;
  text-align: center;
}

.generate-posters .item .icon-img01 {
  content: url("https://dandelion.media.lcwlit.com/images/static/images/icon_line_1.png");
  height: 80px;
  width: 80px;
  margin-top: 20px;
}

.generate-posters .item .icon-img02 {
  content: url("https://dandelion.media.lcwlit.com/images/static/images/icon_line_2.png");
  height: 80px;
  width: 80px;
  margin-top: 20px;
}

.generate-posters .item .imgtitle {
  background-color: #fff;
  font-size: 14px;
}

.disable-btn {
  background: #999999;
  pointer-events: none;
}

.align-center {
  display: flex;
  text-align: center;
}

.poster-box {
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  img {
    border-width: 0;
  }

  img:not([src]) {
    opacity: 0;
  }
}
</style>
